<template>
  <div v-loading="formLoading">
       <!-- 履约能力 -->
     <div class="secondStep table_form_area">
      <el-form
        label-width=""
        class="demo-ruleForm"
        :model="newExtForm"
        ref="ruleForm1"
      >
        <div class="title">
          <span></span>
          <div>基本条件</div>
        </div>
        <el-row>
          <el-col :span="24" class="checkbox_area">
            <el-form-item
              label-width="115px"
              label="分包商业务类别："
              :rules="rules1.subconCooProfessionBOS"
              prop="subconCooProfessionList"
            >
            <el-checkbox-group v-model="newExtForm.subconCooProfessionList">
              <el-checkbox v-for="item in industryCategoryList"  @change="(val) => checkboxChange(val, item.id)" :key="item.id" :label="item.id" name="type">{{ item.name }}</el-checkbox>
            </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="checkbox_area">
            <el-tabs type="card" v-model="activeName" @tab-click="handleClick">
              <el-tab-pane v-for="(item, index) in tabs" :key="item.name" :label="item.label" :name="item.name">
                <el-row>
                  <el-col :span="12" class="addTabIndex deviation">
                    <el-form-item
                      label-width="80px"
                      label="成立年限："
                      :rules="rules1.companySetupTime"
                      prop="subconBaseInfo.companySetupTime"
                    >
                      <el-input
                        disabled
                        style="width: 300px"
                        v-model="newExtForm.subconBaseInfo.companySetupTime"
                        placeholder="请输入成立年限"
                        maxlength="10"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12" class="addTabIndex deviation">
                    <el-form-item
                      label-width="200px"
                      :label="`从事${tabName}年限：`"
                      :rules="rules1.professionalYears"
                      :prop="`subconCooProfessionBOS.${index}.attribute2`"
                    >
                      <el-input
                        style="width: 300px"
                        v-model="newExtForm.subconCooProfessionBOS[index].attribute2"
                        oninput="value=value.replace(/[^0-9.]/g,'')"
                        :placeholder="`请输入从事${tabName}年限`"
                        maxlength="5"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24" class="addTabIndex deviation">
                    <el-form-item
                      label=""
                      :rules="rules1.subconCooProfessionBOS"
                      prop="subconCooProfessionList"
                    >
                      <subcontractingProfession
                        ref="qualificationList1"
                        :professionId="item.name"
                        :checkedTableData="newExtForm.subconCooProfessionBOS[index] ? newExtForm.subconCooProfessionBOS[index].subconCooSubjectBOS : []"
                        @setProfession="setProfession"
                      />
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-tab-pane>
            </el-tabs>
          </el-col>
        </el-row>
        <el-row style="1195px !important"></el-row>
      </el-form>
    </div>
     <!-- 履约能力 -->
     <div class="secondStep table_form_area">
      <el-form
        label-width=""
        class="demo-ruleForm"
        :model="newExtForm"
        ref="ruleForm2"
      >
        <div class="title">
          <span></span>
          <div>履约能力</div>
        </div>
        <el-row>
          <el-col :span="24" class="addTabIndex deviation">
            <el-form-item
              :rules="qualificationListRule8"
              :mode="newExtForm.subconCooPfeBOS"
              label-width=""
              label=""
              prop="list"
            >
              <performanceCapability
                :extTable="newExtForm.subconCooPfeBOS"
                ref="qualificationList2"
              ></performanceCapability>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="newExtForm.subconBaseInfo.isJoinMerge == '1'">
          <el-col :span="24" class="addTabIndex deviation">
            <el-form-item
              ref="uplodFile3"
              :rules="rules4.informationOfPoliticalReview"
              prop="subconBaseInfo.informationOfPoliticalReview"
              label-width="82px"
              label="政审材料："
            >
              <qualificationCertificate
                :uploadUrl="thirdFiles.zscl"
                @qualifications="qualifications5"
              ></qualificationCertificate>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="1195px !important"></el-row>
      </el-form>
    </div>
     <!-- 底部按钮 -->
     <div class="secondStep buttons">
      <el-form
        label-width=""
        class="demo-ruleForm"
        :model="{}"
        ref="buttons"
      >
        <el-row style="1195px !important"></el-row>
        <el-form-item>
          <el-button @click="submitForm('ruleForm')">提交</el-button>
          <el-button class="stopBtn" @click="saveForm()">暂存</el-button>
          <el-button class="lastBtn" @click="lastStep('ruleForm')"
            >上一步</el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { dealSubconRegister } from "@/api/subcontractor-register";
import upload from "../components/upload.vue";
// 上传附件
import qualificationCertificate from "../components/qualificationCertificate.vue";
// 分包专业
import subcontractingProfession from "../components/subcontractingProfession.vue";
// 履约能力
import performanceCapability from "../components/performanceCapability.vue";
export default {
  components: {
    upload,
    qualificationCertificate,
    subcontractingProfession,
    performanceCapability
  },
  props: {
    thirdStepId: "",
    extForm: {
      type: Object,
      default: () => {
        return {};
      }
    },
    extTable: {
      type: Array,
      default: () => {
        return [];
      }
    },
    industryCategoryList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    thirdFiles: {
      type: Object,
      default: () => {
        return {
          zscl: null
        };
      }
    },
  },
  data() {
    return {
      formLoading: false,
      newExtForm: this.extForm,
      qualificationListRule8: {
        list: [
          { required: true, message: "履约能力不能为空", trigger: "change" }
        ]
      },
      rules4: {
        informationOfPoliticalReview: [
          {
            required: true,
            message: "请上传政审材料附件",
            trigger: "change"
          }
        ],
      },
      formTip: {},
      rules1: {
        subconCooProfessionBOS: [
          { type: 'array', required: true, message: '请至少选择一个分包商业务类别', trigger: 'change' }
        ],
        companySetupTime: [
          {  required: true, message: '请输入成立年限', trigger: 'blur' }
        ],
        professionalYears: [
          {  required: true, message: '请输入从事业务年限', trigger: 'blur' }
        ],
      },
      tabs: [],
      tabName: "",
      activeName: ""
    };
  },
  mounted() {
    this.newExtForm.subconBaseInfo.companySetupTime = this.newExtForm.subconBaseInfo.companySetupTime.slice(0,10)
  },
  created(){
    this.setFiles();
    this.setProfessionList();
  },
  methods: {
    setProfessionList(){
      let stagingCategory = this.newExtForm.subconCooProfessionBOS.map(item => {
        let ele = {
          label: item.professionName,
          name: item.professionId
        }
        this.tabs.push(ele);
        return item.professionId
      })
      this.$set(this.newExtForm, "subconCooProfessionList" ,stagingCategory);
      this.activeName = this.newExtForm.subconCooProfessionList[0];
      this.tabName = this.newExtForm.subconCooProfessionBOS[0].professionName;
    },
    setFiles(){
      if(this.extForm.subconBaseFileinfoBOS && this.extForm.subconBaseFileinfoBOS.length > 0){
        let files = this.extForm.subconBaseFileinfoBOS;
        files.forEach(item => {
          switch (item.businessFileType){
            case "17":
              this.thirdFiles.zscl = item;
              break;
          }
        })
      }
    },
    checkboxChange(val, id) {
      if(val){
        let industryCategory = this.industryCategoryList.filter(item => item.id == id);
        let ele1 = {
          label: industryCategory[0].name,
          name: industryCategory[0].id
        }
        this.tabs.push(ele1);
        let ele2 = {
          professionName: industryCategory[0].name,
          professionId: industryCategory[0].id,
          subconCooSubjectBOS: [],
          attribute2: ""
        }
        this.newExtForm.subconCooProfessionBOS.push(ele2)
      }else {
        let index = this.tabs.findIndex(item => item.name == id);
        this.tabs.splice(index, 1);
        this.newExtForm.subconCooProfessionBOS.splice(index, 1);
      }
      if(this.newExtForm.subconCooProfessionBOS.length == 1){
        this.$nextTick(() => {
          this.activeName = this.newExtForm.subconCooProfessionBOS[0].professionId
        })
      }
    },
    setProfession(val, id){
      this.newExtForm.subconCooProfessionBOS.forEach(item => {
        if(item.professionId == id){
          item.subconCooSubjectBOS = val;
        }
      })
    },
    handleClick(val) {
      console.log(val)
      this.tabName = val.label
    },
    lastStep() {
      this.$emit("getStep", 1);
    },
    qualifications5(url) {
      if (
        this.newExtForm.subconCooPfeChange &&
        this.newExtForm.subconCooPfeChange.length <= 0
      ) {
        this.newExtForm.subconCooPfeChange.push({
          id: 1
        });
      }
      if(url) {
        this.thirdFiles.zscl = url;
        this.newExtForm.subconBaseInfo.informationOfPoliticalReview = url.uploadId;
        this.$refs.uplodFile3.clearValidate()
      }else {
        this.thirdFiles.zscl = null;
        this.newExtForm.subconBaseInfo.informationOfPoliticalReview = "";
        this.extForm.subconBaseFileinfoBOS = this.extForm.subconBaseFileinfoBOS.filter(item => item.businessFileType !== "17");
      }
    },

    getUrl1(url){
      this.newExtForm.subconManagePersonAndFilesBO.subconFileinfoBOS[0] = url;
    },
    // 获取事件
    getDate(dateData) {
      let date = new Date(dateData);
      let y = date.getFullYear();
      return y;
    },
    saveForm() {
      console.log(this.newExtForm)
      var that = this;
      this.formLoading = true;
      let params = {
        type: "1",
        subFlag: "0",
        checkState: 3,
        subconBaseInfoBO: this.newExtForm.subconBaseInfo,
        subconCooProfessionBOS: this.newExtForm.subconCooProfessionBOS,
        subconCooPfeBOS: this.newExtForm.subconCooPfeBOS,
        subconAuthAccountInfoBO: this.newExtForm.subconAuthAccountInfo,
        subconCooUnitInfoBO: this.newExtForm.subconCooUnitInfo,
      }
      dealSubconRegister(params).then(
        res => {
          this.formLoading = false;
          if (res.data.code === "0") {
            this.$message({
              showClose: true,
              type: "success",
              message: "暂存成功",
              ccuiCustom: true
            });
          } else {
            this.$message({
              showClose: true,
              type: "error",
              message: res.data.message,
              ccuiCustom: true
            });
          }
        },
        error => {
          this.formLoading = false;
        }
      );
    },
    submitForm(formName) {
      console.log(this.newExtForm)
      this.$refs.qualificationList2.ruleFun();  // 履约能力
      const p1 = new Promise((resolve, reject) => {
          this.$refs.ruleForm1.validate(valid => {
            if (valid) {
              this.formTip.flag1 = true;
              resolve();
            } else {
              this.$nextTick(() => {
                let isError = document.getElementsByClassName("is-error");
                isError[0].scrollIntoView({
                  block: "center",
                  behavior: "smooth",
                });
              });
              this.formTip.flag1 = false;
              return false
            }
          });
        });
        const p2 = new Promise((resolve, reject) => {
          this.$refs.ruleForm2.validate(valid => {
            if (valid) {
              this.formTip.flag2 = true;
              resolve();
            } else {
              this.$nextTick(() => {
                let isError = document.getElementsByClassName("is-error");
                isError[0].scrollIntoView({
                  block: "center",
                  behavior: "smooth",
                });
              });
              this.formTip.flag2 = false;
              return false
            }
          });
        });
        let { flag1, flag2 } = this.formTip;
        if (!flag1 || !flag2 ) {
          this.$emit("open");
        }else {
          for(let i=0; i < this.newExtForm.subconCooProfessionBOS.length; i++){
            if(this.newExtForm.subconCooProfessionBOS[i].subconCooSubjectBOS.length == 0){
              this.activeName = this.newExtForm.subconCooProfessionBOS[i].professionId;
              let message = `请选择${this.newExtForm.subconCooProfessionBOS[i].professionName}的分包专业`
              this.$message({
                type: "warning",
                showClose: true,
                message: message,
                ccuiCustom: true
              });
              this.$refs.qualificationList1.$el.scrollIntoView({
                block: "end",
                behavior: "smooth",
              });
              return false;
            }
          }
          this.newExtForm.subconCooProfessionBOS.forEach(item => {
            if(item.subconCooSubjectBOS.length == 0){

            }
          })
          if (this.newExtForm.subconCooPfeBOS.length <= 0) {
            this.$message({
              type: "warning",
              showClose: true,
              message: "履约能力列表不能为空",
              ccuiCustom: true
            });
            this.$refs.qualificationList2.$el.scrollIntoView({
              block: "end",
              behavior: "smooth",
            });
            return false;
          }
          if (this.$refs.qualificationList2.checkOut){
          Promise.all([p1, p2]).then(async () => {
            this.formLoading = true;
            let params = {
              type: "1",
              subFlag: "1",
              checkState: 3,
              subconBaseInfoBO: this.newExtForm.subconBaseInfo,
              subconCooProfessionBOS: this.newExtForm.subconCooProfessionBOS,
              subconCooPfeBOS: this.newExtForm.subconCooPfeBOS,
              subconAuthAccountInfoBO: this.newExtForm.subconAuthAccountInfo,
              subconCooUnitInfoBO: this.newExtForm.subconCooUnitInfo,
            }
            dealSubconRegister(params).then(
              res => {
                this.formLoading = false;
                if (res.data.code === "0") {
                  this.$router.push("/subcon-submit-success");
                } else {
                  this.$message({
                    showClose: true,
                    type: "error",
                    message: res.data.message,
                    ccuiCustom: true,
                  });
                }
              },
              error => {
                this.formLoading = false;
              }
            );
          })
        }
      }
    },
  },
  watch: {}
};
</script>

<style lang="scss" scoped>
.secondStep{
  padding: 0 90px;
  .title {
    width: 100%;
    height: 50px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #000000;
    position: relative;
    line-height: 20px;
    span {
      margin-right: 16px;
      height: 20px;
      display: inline-block;
      width: 4px;
      background: #ff152e;
    }
    div {
      position: absolute;
      //   top: -2px;
      display: inline-block;
    }
  }
  
}
.form_area{
  /deep/ .el-form-item{
    margin-bottom: 30px;
    .el-select {
      width: 100%;
    }
    .el-input__inner {
      height: 40px !important;
    }
    .el-date-editor {
      width: 100%;
    } 
  }
}
.table_form_area {
  /deep/ .el-table__body .cell {
    overflow: visible;
    .el-form-item__error {
      padding-top: 0px;
    }
  }
}
.buttons {
  display: flex;
  justify-content: center;
    /deep/ .el-button {
    width: 82px;
    height: 40px;
    background: #ff152e;
    border-radius: 2px;
    font-size: 14px;
    border: none;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
  }
  .stopBtn {
    background: rgba(180, 111, 117, 0.08);
    border: 1px solid #ff152e;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ff152e;
  }
  .lastBtn {
    background: #fafafa;
    border: 1px solid #dddddd;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.25);
  }
}
.checkbox_area {
  /deep/ .el-checkbox {
    width: 130px;
    line-height: 30px;
  }
}
</style>
